module.exports = __webpack_public_path__ + "static/media/guanggao.a1106d7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/guanggao.png
// module id = 293
// module chunks = 0